import { isCapacitorNative } from 'environments/environment-helpers';

export const APPLE_EULA_URL = 'https://www.apple.com/legal/internet-services/itunes/dev/stdeula/';

// why this helper exists: on capacitor ios, <a target="_blank">
// navigates the main app webview instead of opening externally —
// firebase hosting's spa fallback then serves index.html at the link
// path and the user appears to "redirect back to login." routing
// through @capacitor/browser opens a separate safari overlay that
// returns via the done button without touching app state. on web,
// fall back to window.open.
export async function openExternalLink(url: string): Promise<void> {
  if (isCapacitorNative()) {
    const { Browser } = await import('@capacitor/browser');
    await Browser.open({ url });
  } else {
    window.open(url, '_blank', 'noopener,noreferrer');
  }
}
